import { Plugin } from '../../types';
import { buildSelector } from '../../web/selector';

export const file: Plugin = {
  name: 'file',
  page: (emit) => {
    document.addEventListener('change', (e) => {
      const element = e.composedPath()[0] as any

      if (element.tagName === 'INPUT' && element.type === 'file') {
        const now = Date.now()
        const selector = buildSelector({
          attribute: "",
          isClick: false,
          target: element as HTMLElement,
        })
        const files = [] as any[]
        for (const f of element.files) {
          files.push({
            name: f.name,
            mimeType: f.type,
            size: f.size
          })
        }
        emit('file', {
          type: 'upload',
          time: now,
          files,
          selector
        });
      }
    })



    return () => {
      // window.document.removeEventListener(downlistener)
      // window.document.removeEventListener(uplistener)
    }
  },

  generate(event) {
    if (event.selector) {
      event.selector = event.selector.replace(/'/gi, "\\'")
    }
    if (event.type === 'upload') {
      if (event.selector) {
        return `
        it("uploads files on \`${event.selector.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toUploadFiles('${event.selector.replace(/'/g, '"')}', ${JSON.stringify(event.files)})
        })
        `
      }
    }
    return ''
  },
  test: {
    matchers: {
      toUploadFiles: async (page, selector, files) => {
        try {
          await page.setInputFiles(selector, files.map(f => {
            return {
              ...f,
              buffer: Buffer.from('test_file')
            }
          }));;
          return { pass: true, message: () => "Page uploads files on " + selector };
        } catch (err) {
          console.log(err)
          return {
            pass: false,
            message: () => "Page did not upload files on  " + selector,
          };
        }
      },

    },

  }
};

export default file